"use client";

import { useActiveDocument } from "@/context/active-document";
import { EditorContext } from "@tiptap/react";
import { useEffect } from "react";
import { useCollabEditor, UseCollabEditorOnUpdate } from "./use-collab-editor";
import { WriterContent } from "./WriterContent";
import { WriterThreadsProvider } from "./WriterThreadsContext";

export const CollabWriter: React.FC<{
  tiptapPath?: string | null;
  documentUuid?: string | null;
  onUpdate: UseCollabEditorOnUpdate;
  onInitialize: UseCollabEditorOnUpdate;
  disabled?: boolean;
}> = ({
  tiptapPath = null,
  documentUuid = null,
  onUpdate,
  onInitialize,
  disabled = false,
}) => {
  const { editor, provider, selectedThreadId, isConnected, versionHistory } =
    useCollabEditor(documentUuid, tiptapPath, {
      onUpdate,
      onInitialize,
    });

  const { setActiveEditor } = useActiveDocument();
  useEffect(() => {
    setActiveEditor(editor);
    return () => setActiveEditor(null);
  }, [editor, setActiveEditor]);

  function handleBackgroundClick(e: React.MouseEvent<HTMLDivElement>) {
    if (e.currentTarget === e.target) {
      editor?.commands.focus();
    }
  }

  return (
    <div className="relative flex w-full flex-grow flex-col overflow-hidden">
      <EditorContext.Provider value={{ editor }}>
        <WriterThreadsProvider
          editor={editor}
          provider={provider}
          selectedThreadId={selectedThreadId}
        >
          <WriterContent
            editor={editor}
            provider={provider}
            isConnected={isConnected}
            versionHistory={versionHistory}
            onBackgroundClick={handleBackgroundClick}
          />
        </WriterThreadsProvider>
      </EditorContext.Provider>
      {disabled && (
        <div className="bg-background/50 absolute inset-0 cursor-not-allowed" />
      )}
    </div>
  );
};
